import { render, staticRenderFns } from "./ProductLcaByCategory.vue?vue&type=template&id=2c9ab260"
import script from "./ProductLcaByCategory.vue?vue&type=script&lang=js"
export * from "./ProductLcaByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports